import React from 'react'
import ReactModal from 'react-modal'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import ExpertForm from '@root/Expert/ExpertPage/Components/ExpertForm'
import ProjectForm from '@root/Project/ProjectPage/Components/ProjectForm'
import ProjectCategoryForm from '@root/Project/ProjectPage/Components/ProjectForm/ProjectCategoryForm'
import SegmentForm from '@root/Project/ProjectPage/Components/SegmentForm'
import ModalButtons from './ModalButtons'
import EPLCancellationModal from '@components/EPLCancellationModal'
import EPLInterviewedModal from '@components/EPLInterviewedModal'
import ExpertPaymentDetailsForm from '@root/Expert/ExpertPage/Components/ExpertPaymentDetailsForm'
import ClientViewExpertProfile from '@root/Project/ProjectPage/ClientView/ExpertProfile'
import ExpertToProjectForm from '@root/Project/ProjectPage/Components/ExpertToProjectForm'
import EditEpl from '@root/Project/ProjectPage/ExpertsPipeline/EditEpl'
import ScheduleCalendarModal from '@root/Project/ProjectPage/ExpertsPipeline/ScheduleCalendarModal'
import ZoomMeetingModal from '@root/Project/ProjectPage/ExpertsPipeline/ScheduleCalendarModal/ZoomMeeting'
import InvoiceForm from '@root/Invoice/Components/InvoiceForm'
import InvoiceFeesForm from '@root/Invoice/Components/InvoiceForm/InvoiceFeesForm'
import InvoiceItemsForm from '@root/Invoice/Components/InvoiceForm/InvoiceItemsForm'
import InvoicePaymentForm from '@root/Invoice/Components/InvoiceForm/InvoicePaymentForm'
import DisapproveInvoiceModal from '@root/Invoice/Components/DisapproveInvoiceModal'
import SetInvoiceCreatedStatusModal from '@root/Invoice/Components/SetInvoiceCreatedStatusModal'
import get from 'lodash/get'
import CloseIcon from '../Icon/SmallCross'
import FeeForm from '@root/Project/ProjectPage/Components/FeeForm'
import BackdatingFeeForm from '@root/Project/ProjectPage/Components/BackdatingFeeForm'
import InviteExpert from '@root/Project/ProjectPage/ExpertsPipeline/ScheduleCalendarModal/InviteExpert'
import InviteClient from '@root/Project/ProjectPage/ExpertsPipeline/ScheduleCalendarModal/InviteClient'
import InterviewScheduleDone from '@root/Project/ProjectPage/ExpertsPipeline/ScheduleCalendarModal/InterviewScheduleDone'
import ClosingNote from '@root/Project/ProjectPage/Components/ClosingNote'
import ClientFeedback from '@root/Project/ProjectPage/Components/ClientFeedback/ClientFeedback'
import ExpertFeedback from '@root/Expert/ExpertPage/ExpertHistory/ExpertFeedback'
import ScreeningQuestions from '@root/Expert/ExpertPage/ExpertHistory/ScreeningQuestions'
import ParentAccountForm from '@root/ClientRecords/ParentAccountForm'
import InvoicingEntityForm from '@root/ClientRecords/InvoicingEntityForm'
import AccountForm from '@root/ClientRecords/AccountForm'
import ClientContactForm from '@root/ClientContact/ClientContactForm'
import OfficeForm from '@root/ClientRecords/OfficeForm'
import AtheneumOfficeForm from '@root/Admin/AtheneumOfficePage/AtheneumOfficeForm'
import EpdRejectionReasonForm from '@root/Admin/EpdRejectionReasonPage/EpdRejectionReasonForm'
import ComplianceForm from '@root/Admin/CompliancePage/ComplianceForm'
import ContractForm from '@root/Contract/ContractForm'
import LinkContractsForm from '@root/Contract/ContractPage/LinkContractsForm'
import RolloverCreditsForm from '@root/Contract/ContractPage/RolloverCreditsForm'
import LinkedContractUpdateForm from '@root/Contract/ContractPage/LinkedContractUpdateForm'
import BatchContractsAssign from '@root/Project/ProjectPage/Outcome/BatchContractsAssign'
import EmployeeForm from '@root/Employee/Components/EmployeeForm'
import RevisionDiffModal from '@components/Logs/RevisionDiffModal'
import ExtractEplsInfoModal from '@components/Logs/ExtractEplsInfoModal'
import GeneralAdjustmentForm from '@root/Reports/FinancialRevenue/GeneralAdjustmentForm'
import EmailTemplateEditForm from '@root/EmailTemplates/EmailTemplateEditForm'
import EmailTemplateSendForm from '@root/EmailTemplates/EmailTemplateSendForm'
import LoginAsModal from '@components/LoginAs/LoginAsModal'
import TeamModal from '@root/Team/TeamModal.js'
import AddEmployeeModal from '@root/Team/AddEmployeeModal.js'
import ProfileForm from '@root/Profile/ProfileForm'
import GetContactInfoModal from '@root/Expert/ExpertPage/Components/GetContactInfoModal'
import CpdForm from '@root/Reports/ExpertPayments/CpdForm'
import ExpertStatusChangeComment from '@root/Expert/ExpertPage/Components/ExpertForm/ExpertStatusChangeComment'
import ExpertComplianceStatusChangeComment from '@root/Expert/ExpertPage/Components/ExpertForm/ExpertComplianceStatusChangeComment'
import ClientContactStatusChangeComment from '@root/ClientContact/ClientContactStatusChangeComment'
import ProjectDeleteModal from '@root/Project/ProjectPage/Details/ProjectDeleteModal'
import HFCompliancePdfExportModal from '@root/Expert/ExpertPage/HFCompliance/HFCompliancePdfExportModal.js'
import PositionForm from '@root/Employee/Components/Positions/PositionForm'
import EditActions from '@root/ProjectManagement/EditActions'
import EplExportModal from '@root/Project/ProjectPage/Components/EplExportModal'
import EYComplianceDialog from '@root/Project/ProjectPage/ExpertsPipeline/Compliance/EYComplianceDialog'
import ClientProjectLinkModal from '@root/Project/ProjectPage/Components/ClientProjectLinkModal'
import ExpertBulkCreate from '@root/Expert/components/ExpertBulkCreate'

import classNames from 'classnames'

import './Modal.sass'

const ModalTypes = {
  EXPERT_FORM: ExpertForm,
  EXPERT_TO_PROJECT_FORM: ExpertToProjectForm,
  CLIENT_VIEW_EXPERT_PROFILE: ClientViewExpertProfile,
  PROJECT_FORM: ProjectForm,
  PROJECT_CATEGORY_FORM: ProjectCategoryForm,
  EXPERT_PAYMENT_DETAILS_FORM: ExpertPaymentDetailsForm,
  SEGMENT_FORM: SegmentForm,
  EPL_CANCELLATION_MODAL: EPLCancellationModal,
  EPL_INTERVIEWED_MODAL: EPLInterviewedModal,
  FEE_FORM: FeeForm,
  BACKDATING_FEE_FORM: BackdatingFeeForm,
  EDIT_EPL: EditEpl,
  INVOICE_FORM: InvoiceForm,
  INVOICE_ADD_FEES_FORM: InvoiceFeesForm,
  INVOICE_ITEMS_FORM: InvoiceItemsForm,
  INVOICE_PAYMENT_FORM: InvoicePaymentForm,
  DISAPPROVE_INVOICE_MODAL: DisapproveInvoiceModal,
  SET_INVOICE_CREATED_STATUS_MODAL: SetInvoiceCreatedStatusModal,
  SCHEDULE_CALENDAR_MODAL: ScheduleCalendarModal,
  ZOOM_MEETING_MODAL: ZoomMeetingModal,
  INVITE_EXPERT: InviteExpert,
  EPL_EXPORT_MODAL: EplExportModal,
  INVITE_CLIENT: InviteClient,
  INTERVIEW_SCHEDULE_DONE: InterviewScheduleDone,
  CLOSING_NOTE: ClosingNote,
  EXPERT_STATUS_CHANGE_COMMENT: ExpertStatusChangeComment,
  EXPERT_COMPLIANCE_STATUS_CHANGE_COMMENT: ExpertComplianceStatusChangeComment,
  CLIENT_CONTACT_STATUS_CHANGE_COMMENT: ClientContactStatusChangeComment,
  CLIENT_FEEDBACK: ClientFeedback,
  EXPERT_FEEDBACK: ExpertFeedback,
  SCREENING_QUESTIONS: ScreeningQuestions,
  PARENT_ACCOUNT_FORM: ParentAccountForm,
  INVOICING_ENTITY_FORM: InvoicingEntityForm,
  ACCOUNT_FORM: AccountForm,
  CLIENT_CONTACT_FORM: ClientContactForm,
  OFFICE_FORM: OfficeForm,
  ATHENEUM_OFFICE_FORM: AtheneumOfficeForm,
  LINKED_CONTRACTS_FORM: LinkContractsForm,
  CONTRACT_FORM: ContractForm,
  ROLLOVER_CREDITS_FORM: RolloverCreditsForm,
  LINKED_CONTRACT_UPDATE_FORM: LinkedContractUpdateForm,
  BATCH_CONTRACT_ASSIGN: BatchContractsAssign,
  EMPLOYEE_FORM: EmployeeForm,
  REVISION_DIFF_MODAL: RevisionDiffModal,
  EXTRACT_EPLS_INFO_MODAL: ExtractEplsInfoModal,
  GENERAL_ADJUSTMENT_FORM: GeneralAdjustmentForm,
  EMAIL_TEMPLATE_EDIT: EmailTemplateEditForm,
  EMAIL_TEMPLATE_SEND: EmailTemplateSendForm,
  EPD_REJECTION_REASON_FORM: EpdRejectionReasonForm,
  COMPLIANCE_FORM: ComplianceForm,
  LOGIN_AS_MODAL: LoginAsModal,
  TEAM_MODAL: TeamModal,
  ADD_EMPLOYEE_MODAL: AddEmployeeModal,
  PROFILE_FORM: ProfileForm,
  GET_CONTACT_INFO: GetContactInfoModal,
  CPD_FORM: CpdForm,
  PROJECT_DELETE_MODAL: ProjectDeleteModal,
  HF_COMPLIANCE_PDF_EXPORT: HFCompliancePdfExportModal,
  POSITION_FORM: PositionForm,
  EDIT_ACTIONS: EditActions,
  EY_COMPLIANCE_DIALOG: EYComplianceDialog,
  CLIENT_PROJECT_LINK: ClientProjectLinkModal,
  EXPERT_BULK_CREATE: ExpertBulkCreate
}

const modalContentClassNames = {
  base: 'modal__content',
  afterOpen: 'modal__content--after-open',
  beforeClose: 'modal__content--before-close'
}

const modalContentSegmentClassNames = {
  base: 'modal__content--segment',
  afterOpen: 'modal__content--after-open-segment',
  beforeClose: 'modal__content--before-close-segment'
}

const modalOverlayClassNames = {
  base: 'modal__overlay',
  afterOpen: 'modal__overlay--after-open',
  beforeClose: 'modal__overlay--before-close'
}

const ModalWrapper = ({ modalStore }) => {
  let modalContent
  let Modal
  let defaultProps = {}

  const scrollToTop = (smooth = false) => {
    const modalOverlay = document.querySelector('.modal__overlay')
    if (modalOverlay && typeof modalOverlay.scrollTo === 'function') {
      modalOverlay.scrollTo({ left: 0, top: 0, behavior: smooth ? 'smooth' : 'instant' })
    }
  }

  const scrollToBottom = (smooth = false) => {
    const modalOverlay = document.querySelector('.modal__overlay')
    if (modalOverlay && typeof modalOverlay.scrollTo === 'function') {
      modalOverlay.scrollTo({ left: 0, top: modalOverlay.scrollHeight, behavior: smooth ? 'smooth' : 'instant' })
    }
  }

  if (modalStore.type) {
    Modal = ModalTypes[modalStore.type]

    if (!Modal) throw new Error(`Modal not registered: ${modalStore.type}`)

    defaultProps = get(Modal, 'wrappedComponent.defaultProps') || Modal.defaultProps || {}

    modalContent = <Modal {...Object.assign({ scrollToTop: scrollToTop, scrollToBottom: scrollToBottom }, modalStore.props)} />
  }

  const isVisible = modalStore.config.isOpen
  const shouldCloseOnOverlayClick =
    defaultProps.shouldCloseOnOverlayClick !== undefined
      ? defaultProps.shouldCloseOnOverlayClick
      : modalStore.props.shouldCloseOnOverlayClick

  const shouldShowCloseIcon =
    defaultProps.showCloseIcon !== undefined
      ? defaultProps.showCloseIcon
      : modalStore.props.showCloseIcon
  const closeIcon = shouldShowCloseIcon ? (
    <CloseIcon onClick={modalStore.close} className="close-icon" />
  ) : null

  const isException = modalStore.type === 'SEGMENT_FORM'

  const baseClasses = classNames({
    [modalContentClassNames.base]: true,
    [modalContentSegmentClassNames.base]: isException,
    [defaultProps.class]: defaultProps.class,
    'modal__content--wide': defaultProps.wideContent,
    'modal__content--thin': defaultProps.thinContent
  })



  const classes = isException
    ? {
      ...modalContentSegmentClassNames,
      base: baseClasses
    }
    : {
      ...modalContentClassNames,
      base: baseClasses
    }

  return (
    <ReactModal
      onAfterOpen={scrollToTop}
      isOpen={isVisible}
      contentLabel="Modal"
      className={classes}
      overlayClassName={modalOverlayClassNames}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={modalStore.close}
      closeTimeoutMS={modalStore.closeTimeoutInMs}>
      {closeIcon}
      {modalContent}
      <ModalButtons
        {...modalStore.props}
        {...defaultProps}
        close={modalStore.close}
      />
    </ReactModal>
  )
}

ModalWrapper.propTypes = {
  modalStore: PropTypes.shape({
    type: PropTypes.string,
    config: PropTypes.object,
    props: PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.node,
      okText: PropTypes.string,
      cancelText: PropTypes.string,
      hideCancelButton: PropTypes.bool,
      hideButtons: PropTypes.bool,
      onOk: PropTypes.func,
      onCancel: PropTypes.func,
      showCloseIcon: PropTypes.bool,
      wideContent: PropTypes.bool,
      thinContent: PropTypes.bool
    })
  })
}

export default inject('modalStore')(observer(ModalWrapper))
